import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InfoBox from '../info-box';
import styles from './style.module.css';

class Tips extends Component {
    getCurrentRoute() {
        const {
            props: {
                location,
                routes = []
            }
        } = this;

        return routes.find(({ path }) => location.pathname.endsWith(path));
    }

    render() {
        const currentRoute = this.getCurrentRoute();

        if (!currentRoute || !currentRoute.tips) {
            return null;
        }

        const { tips } = currentRoute;

        return (
            <div className={styles.container}>
                <InfoBox
                    title={tips.title}
                    content={tips.content}
                    additionalContent={tips.additionalContent}
                    icon={tips.icon}
                    button={tips.button}
                />
            </div>
        );
    }
}

export default withRouter(Tips);
